import { useContext } from 'react';
import { BiddingContext } from '@/context/BiddingContext';
import { useHermesEntry } from '@/hooks/useHermesEntry';

export const useHasAuctionEnded = (isEnded: boolean) => {
  const { entryId, vatPerc, auctionEnd } = useContext(BiddingContext);
  const { hermesEntry } = useHermesEntry(entryId, vatPerc);

  const auctionEndPassed = auctionEnd < new Date();

  return hermesEntry?.isEnded ?? (isEnded || auctionEndPassed);
};
